import { IDefinitionSearchInfo, IDefinition } from '@/interfaces/powerMarkets/static/IDefinitionSearchInfo.ts';
import { useApi, ApiPromise } from '@/api/useApi.ts';

const apiCall = useApi('static');

function getAllDefinitionSearchInfo (): ApiPromise<Array<IDefinitionSearchInfo>> {
    return apiCall.get<Array<IDefinitionSearchInfo>>({
        endpoint: '/Definitions/Search',
    });
}

function getDefinitionById (id: string): ApiPromise<IDefinition> {
    return apiCall.get<IDefinition>({
        endpoint: `/Definitions/Id/${id}`,
    });
}

export const definitionApi = {
    getAllDefinitionSearchInfo,
    getDefinitionById,
};
